import React from 'react';
import PropTypes from 'prop-types';
import { useController, useFormContext } from 'react-hook-form';

import SkuItemAvailabilityStatus from 'features/Sku/Items/components/SkuItemAvailabilityStatus';

import { GROUP_AVAILABILITY_OPTIONS } from '../Modifiers.availability';

const GroupAvailabilityDropdown = ({ name, disabled }) => {
  const { control } = useFormContext();
  const {
    field: { value, onChange },
  } = useController({ name, control });

  return (
    <SkuItemAvailabilityStatus
      status={value}
      statusOptions={GROUP_AVAILABILITY_OPTIONS}
      onChange={disabled ? null : onChange}
    />
  );
};

GroupAvailabilityDropdown.propTypes = {
  disabled: PropTypes.bool,
  name: PropTypes.string.isRequired,
};

GroupAvailabilityDropdown.defaultProps = {
  disabled: false,
};

export default GroupAvailabilityDropdown;
